import {UI} from "../../../../stem-core/ui/UIBase.js";
import {JSONStateInput} from "../components/JSONStateInput.jsx";
import {PanelOffersEditor} from "./editor-tabs/PanelOffersEditor";
import {TopLevelTabArea} from "../../../common/theme/TabAreaStyle";
import {PanelContextEditor} from "./editor-tabs/PanelContextEditor";
import {PanelContentEditor} from "./editor-tabs/PanelContentEditor";
import {PanelDeveloperEditor} from "./editor-tabs/PanelDeveloperEditor";
import {PanelPreviewSettingsEditor} from "./editor-tabs/PanelPreviewSettingsEditor.jsx";
import {MechantPanelHistoryPanel} from "./editor-tabs/PanelHistory.jsx";
import type {PanelEditorState} from "./PanelEditorState";


export class PanelEditorInput extends JSONStateInput<{state?: PanelEditorState}> {
    renderSimplifiedMode() {
        const {state} = this.options;

        return <TopLevelTabArea>
            <PanelContextEditor title="Context" state={state} />
            <PanelOffersEditor title="Offers" state={state} />
            <PanelContentEditor title="Content" state={state} />
            <PanelDeveloperEditor title="Developer" state={state} />
            <PanelPreviewSettingsEditor title="Preview Options" state={state} />
            <MechantPanelHistoryPanel title="Past versions" state={state} />
        </TopLevelTabArea>;
    }
}
